import Script from 'next/script';

type GTMScriptsProps = {
  gtmId: string;
};

export function GTMScripts({ gtmId }: GTMScriptsProps) {
  if (!gtmId) {
    return null;
  }

  return (
    <>
      <Script
        key="page-view-gtm"
        id="page-view-gtm"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            originalLocation: document.location.protocol + '//' +
            document.location.hostname +
            document.location.pathname +
            document.location.search
          })`,
        }}
      />

      <Script
        key="gtm"
        id="gtm"
        dangerouslySetInnerHTML={{
          __html: `(function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${gtmId}');`,
        }}
      />

      <noscript key="gtm-noscript">
        <iframe
          title="gtm"
          src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
}
